var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg074Email2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.182,176.53c-0.66-2.298-1.747-4.515-3.275-6.536c-1.132-1.496-2.434-2.787-3.857-3.869 c-3.848-4.765-8.255-9.106-13.161-12.9L299.908,13.311c-0.537-0.416-1.095-0.803-1.672-1.162 c-26.052-16.199-58.422-16.199-84.473,0c-0.577,0.358-1.135,0.746-1.672,1.162L31.11,153.225 c-19.452,15.038-31.065,38.694-31.065,63.281v215.509C0.045,476.119,35.927,512,80.031,512h212.963 c11.044,0,19.997-8.952,19.997-19.997s-8.953-19.997-19.997-19.997H80.03c-22.052,0-39.993-17.941-39.993-39.993V216.506 c0-12.293,5.807-24.121,15.532-31.641l180.098-139.23c12.623-7.465,28.042-7.465,40.665,0l174.497,134.899L276.415,312.478 c-12.681,7.538-28.194,7.53-40.869-0.023l-118.535-88.75c-8.842-6.62-21.373-4.817-27.992,4.022 C82.4,236.568,84.2,249.1,93.04,255.72l119.295,89.318c0.462,0.345,0.938,0.67,1.426,0.975c13.027,8.1,27.632,12.15,42.238,12.15 c14.605,0,29.211-4.05,42.238-12.15c0.517-0.322,1.019-0.667,1.505-1.034L471.92,214.726c0.027,0.592,0.041,1.185,0.041,1.78 v44.538c0,11.044,8.952,19.997,19.997,19.997s19.996-8.952,19.996-19.997v-44.538C511.954,202.388,508.125,188.579,501.182,176.53 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.112,416.054c-7.805-7.816-20.464-7.828-28.28-0.025l-31.864,31.807V335.511c0-11.044-8.952-19.997-19.997-19.997 s-19.997,8.952-19.997,19.997v112.326l-31.865-31.807c-7.817-7.802-20.476-7.791-28.28,0.025 c-7.802,7.816-7.791,20.476,0.025,28.279l59.046,58.94c5.812,5.811,13.443,8.713,21.074,8.713c7.627,0,15.253-2.901,21.055-8.702 l59.057-58.952C513.903,436.531,513.913,423.87,506.112,416.054z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg074Email2);
export default __webpack_public_path__ + "static/media/074-email-2.31f761f7c4ba25685651bccacf51b712.svg";
export { ForwardRef as ReactComponent };